import script from "./BlueDownloadRoundedIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueDownloadRoundedIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__